import { put, call, takeLatest, all } from 'redux-saga/effects';
import * as servicesGrid from 'services/grid';
import * as types from './constants';
import * as actions from './actions';

import { formatMDYHMS, formatMDYWithParam } from 'utils/formatDate';
import { calculateToPercentByParam } from 'utils/formatSizeUnits';

export function* getProductAplColumns(action) {
  const { linkTarget } = action.payload || {};
  try {
    const response = yield call(servicesGrid.gridColumnInfo, 'apl-grid');
    let columns = [
      {
        field: '',
        checkboxSelection: true,
        filter: false,
        suppressMenu: true,
        sortable: false,
      },
    ];
    if (response?.columns?.length > 0) {
      let hiddenCol = [
        'id',
        'ownerCompanyId',
        'createdBy', // createById
        'shareable',
        'type',
        'isRollback',
        'isOwner',
      ];
      const dateList = ['created', 'lastModified'];
      response.columns.forEach((val, index) => {
        if (hiddenCol.indexOf(val.fieldNameCamelCase) === -1) {
          // eslint-disable-next-line no-lone-blocks
          {
            if (val.fieldNameCamelCase === 'aplDescription') {
              val = { ...val, flex: 1, minWidth: 200, resizable: true };
            } else if (dateList.includes(val.fieldNameCamelCase)) {
              val = {
                ...val,
                width: 140,
                cellRenderer: formatMDYWithParam,
                resizable: true,
              };
            } else if (val.fieldNameCamelCase === 'matchedRate') {
              val = {
                ...val,
                width: 120,
                cellRenderer: calculateToPercentByParam,
                resizable: true,
              };
            } else if (val.fieldNameCamelCase === 'lastExecuteMatching') {
              val = {
                ...val,
                width: 120,
                cellRenderer: (param) => {
                  return param ? `${formatMDYHMS(param?.value)}` : '';
                },
                resizable: true,
              };
            } else {
              val = { ...val, width: 160, resizable: true };
            }

            if (val.fieldNameCamelCase === 'aplName')
              val = {
                ...val,
                linkTo: '/products/apl/{id}',
                minWidth: 300,
                linkTarget,
              };

            columns.push(val);
          }
        }
      });
    }

    yield put(actions.getAPLGridColumnsSuccess(columns));
  } catch (error) {
    yield put(actions.getAPLGridColumnsError(error));
  }
}

function* watchAll() {
  yield all([
    takeLatest(types.GET_PRODUCT_APL_GRID_COLUMN, getProductAplColumns),
  ]);
}

export default watchAll;
